import { Panel } from '../ui/Panel';
import { ContentEditor } from '../ui/ContentEditor';
import { SettingNumber } from './SettingNumber';
import { useSettings } from './useSettings';

/**
 * Instellingen › Salon & contact: jij, de salon en de vaste zakelijke gegevens. Naam, adres en
 * Instagram hier zijn ook de voettekst van elke mail (Mail › Huisstijl leest ze hieruit).
 */
export function SalonSettings() {
  const {
    policy,
    setPolicy,
    json
  } = useSettings();
  return <>
      <Panel title="Over jou" description="Je profiel: naam en foto’s op de homepage, Over Sarah, bij het advies en als behandelaar bij boeken." data-id="element-4087" data-mp="29100hz0eq99t">
        <ContentEditor {...json('founder')} data-id="element-4088" data-mp="2isnn9mm0r24y" />
      </Panel>
      <Panel title="De salon" description="Adres en contact — ook in de footer, voor Google Maps en onderaan elke mail." data-id="element-4089" data-mp="2iv9u1k135dm4">
        <ContentEditor {...json('salon')} data-id="element-4090" data-mp="2rtvghq9ohcs6" />
      </Panel>
      <Panel title="Ervaring en bereikbaarheid" description="Staan in teksten op de site, zoals de homepage en het contactformulier." data-id="element-4091" data-mp="2rvezvpqms3y6">
        <div className="grid gap-5 sm:grid-cols-2" data-id="element-4092" data-mp="2i10rw3pzbqx0">
          <SettingNumber label="Jaren ervaring" hint="“Al … jaar huidtherapeut.”" value={policy.yearsExperience} onChange={v => setPolicy('yearsExperience', v)} max={60} data-id="element-4093" data-mp="2i2tvtb97jx1b" />
          <SettingNumber label="Reactietijd (uren)" hint="Hoe snel je op WhatsApp en mail antwoordt." value={policy.responseHours} onChange={v => setPolicy('responseHours', v)} min={1} max={168} data-id="element-4094" data-mp="241r8ywae2ipc" />
        </div>
      </Panel>
      <Panel title="Btw" description="Voor facturen en bonnen, in de webshop en aan de kassa." data-id="element-4095" data-mp="2rywz4kfsq1pu">
        <SettingNumber label="Btw-tarief op de factuur (%)" hint="Het standaardtarief voor producten." value={policy.vatRate} onChange={v => setPolicy('vatRate', v)} max={30} data-id="element-4096" data-mp="2n0n6aghjnd7e" />
      </Panel>
    </>;
}